import React, { useState, useRef, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import "../../../assests/css/teachers/teacherchats.css";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";


const tcRoleLabel = {
    student: "Student",
    teacher: "Teacher",
    admin: "Admin",
};

const TeacherChats = () => {
    console.log("TEACHER CHAT PAGE RUNNING ");
    const { conversationId } = useParams();
    console.log("URL Conversation =", conversationId);
    const { baseUrl } = useContext(AppContext);
    const [disputes, setDisputes] = useState([]);
    const [messages, setMessages] = useState([]);
    const [activeDisputeId, setActiveDisputeId] = useState(null);
    const [newMessage, setNewMessage] = useState("");
    const tcChatBodyRef = useRef(null);

    const tcActiveDispute = disputes.find((d) => d.id === activeDisputeId);

    useEffect(() => {
        if (tcChatBodyRef.current) {
            tcChatBodyRef.current.scrollTop = tcChatBodyRef.current.scrollHeight;
        }
    }, [activeDisputeId, disputes]);

    const handleSelectDispute = (id) => {
        setActiveDisputeId(id);
    };
    const handleSend = async () => {
        console.log("HANDLE SEND CLICKED");
        console.log("HANDLE SEND CLICKED");

        console.log("Message =", newMessage);

        if (!newMessage.trim()) {
            console.log("Message Empty");
            return;
        }

        const teacher = JSON.parse(localStorage.getItem("teacher"));
        console.log(teacher);
        axios
            .post(baseUrl + "/chat/sendMessage", {
                conversation_id: activeDisputeId,
                sender_id: teacher.id,
                sender_role: "teacher",
                message: newMessage,
            })
            .then((response) => {
                console.log("SEND RESPONSE:", response.data);
                if (response.data.success) {
                    setNewMessage("");
                    fetchMessages();
                } else {
                    console.log(response.data.error);
                }
            })
            .catch((error) => {
                console.log("Error:", error);
                if (error.response) {
                    console.log("Status:", error.response.status);
                    console.log("Data:", error.response.data);
                }
            });
    };

    const createConversation = async () => {
        const teacher = JSON.parse(localStorage.getItem("teacher"));
        const admin = JSON.parse(localStorage.getItem("admin"));

        console.log("TEACHER ID:", teacher?.id);
        console.log("ADMIN ID:", admin?.id);

        try {
            const response = await axios.post(
                baseUrl + "/chat/createAdminTeacherConversation",
                {
                    teacher_id: teacher.id,
                    admin_id: admin.id
                }
            );

            console.log("🔥 CREATE RESPONSE:", response.data);

        } catch (error) {
            console.log("❌ CREATE ERROR:", error.response?.data || error);
        }
    };

    useEffect(() => {
        createConversation();
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSend();
        }
    };

    // const handleToggleStatus = () => {
    //     setDisputes((prev) =>
    //         prev.map((d) =>
    //             d.id === activeDisputeId
    //                 ? {
    //                     ...d,
    //                     status: d.helpSupport.status === "Pending" ? "Resolved" : "Pending",
    //                 }
    //                 : d
    //         )
    //     );
    // };
    const fetchMessages = () => {
        console.log("Fetching Conversation =", activeDisputeId);
        axios.post(baseUrl + "/chat/getMessages", {
            conversation_id: activeDisputeId,
        })
            .then((response) => {
                console.log(response.data);
                if (response.data.success) {
                    setMessages(response.data.messages);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };
    const fetchConversations = () => {
        const teacher = JSON.parse(localStorage.getItem("teacher"));
        console.log("🔥 TEACHER OBJECT =", teacher);
        console.log("🔥 TEACHER ID =", teacher?.id);

        axios.post(baseUrl + "/chat/getAdminTeacherChats", {
            teacher_id: teacher.id
        })
            .then((response) => {

                console.log(response.data);

                if (response.data.success) {

                    setDisputes(response.data.conversations);

                    if (conversationId) {

                        setActiveDisputeId(Number(conversationId));

                    } else if (response.data.conversations.length > 0) {

                        setActiveDisputeId(response.data.conversations[0].id);

                    }
                }

            })
            .catch((error) => {
                console.log(error);
            });

    };

    useEffect(() => {
        fetchConversations();
    }, []);
    useEffect(() => {
        if (activeDisputeId) {
            fetchMessages();
        }
    }, [activeDisputeId]);

    return (
        <div className="tc-dispute-page">
            {/* Sidebar: dispute list */}
            <aside className="tc-dispute-sidebar">
                <div className="tc-sidebar-header">
                    <h2 className="tc-sidebar-title">Disputes</h2>
                </div>
                <div className="tc-dispute-list">
                    {disputes.map((d) => {
                        return (
                            <button
                                type="button"
                                key={d.id}
                                className={`tc-dispute-list-item ${d.id === activeDisputeId ? "tc-dispute-list-item-active" : ""
                                    }`}
                                onClick={() => handleSelectDispute(d.id)}
                            >
                                <div className="tc-dispute-item-top">
                                    <span className="tc-dispute-item-title">
                                        Admin
                                    </span>
                                </div>

                                <p className="tc-dispute-item-preview">
                                    {d.recentMessage || "No messages yet"}
                                </p>
                            </button>
                        );
                    })}
                </div>
            </aside>

            {/* Main chat panel */}
            <section className="tc-chat-panel">
                {tcActiveDispute ? (
                    <>
                        <div className="tc-chat-header">
                            <div className="tc-header-titles">
                                <h2 className="tc-header-title">
                                    Admin
                                </h2>
                                <span className="tc-header-participants">
                                    Teacher · Admin
                                </span>
                            </div>
                        </div>

                        <div className="tc-chat-body" ref={tcChatBodyRef}>
                            {messages.map((msg) => {
                                const teacher = JSON.parse(localStorage.getItem("teacher"));
                                const tcIsOwn = msg.sender_id === teacher.id;
                                return (
                                    <div
                                        key={msg.id}
                                        className={`tc-message-row ${tcIsOwn
                                            ? "tc-message-row-own"
                                            : "tc-message-row-other"
                                            }`}
                                    >
                                        <span className="tc-message-sender">
                                            {msg.sender_role}
                                            <span
                                                className={`tc-role-tag tc-role-tag-${msg.sender_role}`}
                                            >
                                                {tcRoleLabel[msg.sender_role]}
                                            </span>
                                        </span>
                                        <div
                                            className={`tc-message-bubble tc-message-bubble-${msg.sender_role} ${tcIsOwn ? "tc-message-bubble-own" : ""
                                                }`}
                                        >
                                            {msg.message}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="tc-input-footer">
                            <input
                                type="text"
                                className="tc-message-input"
                                placeholder="Type your message..."
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                onKeyDown={handleKeyDown}
                            />
                            <button
                                type="button"
                                className="tc-send-btn"
                                onClick={handleSend}
                            >
                                Send
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="tc-empty-state">Select a dispute to view chat</div>
                )}
            </section>
        </div>
    );
};

export default TeacherChats;